import React, { useContext, useEffect, useState } from 'react'
import ConsultasComunes from '../Sql/ConsultasComunes';
import MsgUtils from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
import Modal from 'react-bootstrap/Modal';
const server = process.env.REACT_APP_SERVER;

function ListaColaboradorLink(props) {
    const { regional, encuesta } = props;
    const { setLoading } = useContext(ContextGloball);
    const [colaboradores, setColaboradores] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [idSucursal, setIdsucursal] = useState(-1);
    const [asegurado, setAsegurado] = useState('*');
    const [showModal, setShowModal] = useState(false);
    const [selectColaborador, setSelectColaborador] = useState(null);
    const [ventanaModal, setVentanaModal] = useState(0);
    const [nombreBuscado, setNombreBuscado] = useState(null);
    const [idDepartamento, setIdDepartamento] = useState(-1);
    const [actualizar, setActualizar] = useState(false);
    const [departamentos, setDepartamentos] = useState([]);
    const [idCargo, setIdCargo] = useState(0);
    const [cargos, setCargos] = useState([]);
    const [idEstado, setIdEstado] = useState(0);
    const [estado, setEstado] = useState('A');
    const [estadoBaja, setEstadoBaja] = useState('*');
    const [idTurno, setIdTurno] = useState('*');
    const [idContrato, setIdContrato] = useState('*');
    const [urlFinal,setUrlFinal] = useState('');
    function cambiarDeEstado(valor) {
        setIdEstado(valor);
        if (valor == 5) {
            setEstado('*');
            setEstadoBaja('*');
        } else if (valor == 4) {
            setEstado('I');
            setEstadoBaja('*');
        } else {
            setEstado('A')
            switch (valor) {
                case 0:
                    setEstadoBaja('*');
                    break;
                case 1:
                    setEstadoBaja('N');
                    break;
                case 2:
                    setEstadoBaja('F');
                    break;
                case 3:
                    setEstadoBaja('P');
                    break;
            }
        }
        setActualizar(!actualizar);
    }
    const getDirectorioColaborador = async () => {
        setLoading(true);
        try {
            var directorio = await ConsultasComunes.getCatalogoColaborador({
                "regional": regional,
                "idPerfil": -100,
                "estado": estado,
                "estadoBaja": estadoBaja, idCargo, idTurno, idContrato,
                nombreBuscado, idDepartamento, idSucursal, asegurado
            })

            if (directorio.ok) {
                //console.log(directorio.ok);
                setColaboradores(directorio.ok);
            } else {
                MsgUtils.msgError(directorio.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        } finally {
            setLoading(false);
        }
    }
    function getAntiguedad(valor) {
        var valorFinal = ''
        var años = parseInt(valor / 12)
        if (años > 0) {
            valorFinal = valorFinal + años + ' A'
        }
        var meses = parseInt(valor % 12)
        if (meses > 0) {
            valorFinal = valorFinal + ' ' + meses + ' m'
        }
        if (años <= 0 && meses <= 0) {
            valorFinal = parseInt(valor * 100) + ' d'
        }
        return valorFinal
    }
    const getCargos = async () => {
        try {
            var cargos = await ConsultasComunes.getInfoCategoriasSys({ 'regional': regional, 'tipo': 'TC' });
            if (cargos.ok) {
                setCargos(cargos.ok);
            } else {
                MsgUtils.msgError(cargos.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        }
    }
    const getDepartamentos = async () => {
        try {
            var departament = await ConsultasComunes.getInfoCategoriasSys({ 'regional': regional, 'tipo': 'DE' });
            if (departament.ok) {
                setDepartamentos(departament.ok);
            } else {
                MsgUtils.msgError(departament.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        }
    }
    const getSucursales = async () => {
        try {
            var sucursales = await ConsultasComunes.getSucursales(regional);
            if (sucursales.ok) {
                setSucursales(sucursales.ok);
            } else {
                MsgUtils.msgError(sucursales.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message)
        }
    }
    const generarLinkEncuesta =async(colaborador)=>{
        try {
            var URL = `${encuesta.ID_ENCUESTA}/${regional}/${colaborador.ID_EMPLEADO}`
            var result = await ConsultasComunes.cifrarEncuestaurl({'regional':regional,'URL':URL})
            if(result.ok){
                setSelectColaborador(colaborador);
                setShowModal(true);
                setUrlFinal(`${server}/Encuesta/${result.ok}/${new Date().getMilliseconds()}/${regional}`)
            }else{
                MsgUtils.msgError(result.error)
            }
        } catch (error) {
            MsgUtils.msgError(error.message);
        }
    }
    useEffect(() => {
        getDirectorioColaborador();
    }, [actualizar])
    useEffect(() => {
        getCargos();
        getDepartamentos();
        getSucursales();
    }, [])

    return (
        <div >
            <div className='container-fluid bg-dark py-1'>
                <div className='row row-cols gx-1'>
                    <div className='col' style={{ minWidth: "150px", maxWidth: "150px" }}>
                        <div className=''>
                            <div className="small fw-light text-white">Sucursal</div>
                            <select className='form-select form-select-sm' value={idSucursal}
                                onChange={(e) => { setIdsucursal(parseInt(e.target.value)); setActualizar(!actualizar); }}>
                                <option value="-1">Todas</option>
                                {sucursales.map((sucursal, index) => (
                                    <option key={index} value={sucursal.ID_SUCURSAL}>{sucursal.SUCURSAL}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col" style={{ minWidth: '250px', maxWidth: '250px' }}>
                        <div className="small fw-light text-white">Buscar</div>
                        <div className="input-group input-group-sm">
                            <input className="form-control form-control-sm"
                                placeholder='COLABORADOR'
                                type="text"
                                value={nombreBuscado}
                                onChange={(e) => { setNombreBuscado(e.target.value.toUpperCase()); setActualizar(!actualizar) }} />
                        </div>
                    </div>
                    <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Departamento</div>
                        <select className='form-select form-select-sm'
                            value={idDepartamento}
                            onChange={(e) => { setIdDepartamento(parseInt(e.target.value)); setActualizar(!actualizar) }}>
                            <option value="-1">--TODOS--</option>
                            {departamentos.map((departamento, index) => {
                                return (
                                    <option value={departamento.ID_CATEGORIA} key={index}>{departamento.CATEGORIA}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Cargo</div>
                        <select className='form-select form-select-sm'
                            value={idCargo}
                            onChange={(e) => { setIdCargo(parseInt(e.target.value)); setActualizar(!actualizar) }}>
                            <option value="0">-CUALQUIERA-</option>
                            {cargos.map((cargo, index) => {
                                return (
                                    <option value={cargo.ID_CATEGORIA} key={index}>{cargo.CATEGORIA}</option>
                                )
                            })}
                        </select>
                    </div>
                    <div className='col d-none' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Estado</div>
                        <select className='form-select form-select-sm'
                            value={idEstado}
                            onChange={(e) => { cambiarDeEstado(parseInt(e.target.value)); }}>
                            <option value="0">Activos(incl. Bajas en Proceso)</option>
                            <option value="1">Activos Sin Bajas en Programada</option>
                            <option value="2">Con Baja Programada</option>
                            <option value="3">Con Baja en Proceso</option>
                            <option value="4">Con Baja Finalizada</option>
                            <option value="5">Cualquier Estado</option>
                        </select>
                    </div>
                    <div className='col d-none' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Contrato</div>
                        <select className='form-select form-select-sm'
                            value={idContrato}
                            onChange={(e) => { setIdContrato(e.target.value); setActualizar(!actualizar) }}>
                            <option value="*">-Cualquiera-</option>
                            <option value="KIN">Indefinido</option>
                            <option value="PDE">Plan Desarrollo de Empleo</option>
                            <option value="PAE">PAE</option>
                            <option value="LIM">Pagos por Dia</option>
                            <option value="TEM">Contrato 89 días</option>
                            <option value="REC">Receso</option>
                        </select>
                    </div>
                    <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Asegurado</div>
                        <select className='form-select form-select-sm'
                            value={asegurado}
                            onChange={(e) => { setAsegurado(e.target.value); setActualizar(!actualizar) }}>
                            <option value="*">Todos</option>
                            <option value="S">Si</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                    <div className='col' style={{ minWidth: '150px', maxWidth: '150px' }}>
                        <div className='small fw-light text-white'>Turno</div>
                        <select className='form-select form-select-sm'
                            value={idTurno}
                            onChange={(e) => { setIdTurno(e.target.value); setActualizar(!actualizar) }}>
                            <option value="*">-Cualquiera-</option>
                            <option value="M">Mañana</option>
                            <option value="N">Noche</option>
                            <option value="O">Partido</option>
                            <option value="Q">Corrido</option>
                            <option value="X">Sin Especificar</option>
                        </select>
                    </div>
                    <div className='col d-none' style={{ minWidth: '50px', maxWidth: '50px' }}>
                        <div className='small fw-light text-white'>Cargar</div>
                        <button className='btn btn-sm btn-success w-100' onClick={() => setActualizar(!actualizar)}><i className="fa-solid fa-repeat"></i></button>
                    </div>
                </div>
            </div>
            <div className='overflow-auto' style={{ minHeight: `${window.innerHeight - window.innerHeight * 0.38}px`,maxHeight: `${window.innerHeight - window.innerHeight * 0.38}px` }} >
                <div className='table-responsive'>
                    <table className='table table-dark table-striped table-sm table-bordered' id="tablaColaboradores">
                        <thead>
                            <tr>
                                <th style={{ width: '50px' }}>ID</th>
                                <th style={{ width: '350px' }}>Nombre</th>
                                <th style={{ width: '10px' }}>Ge.</th>
                                <th style={{ width: '200px' }}>Cargo</th>
                                <th style={{ width: '150px' }}>Sucursal</th>
                                <th style={{ width: '120px' }}>Turno</th>
                                <th style={{ width: '130px' }}>Contrato Actual</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {colaboradores.map((colaborador, index) => {
                                return (
                                    <tr key={index}>
                                        <td id={colaborador.EMPRESA_ASEGURADO}>{colaborador.ID_EMPLEADO}</td>
                                        <td>{colaborador.NOMBRE_COMPLETO}</td>
                                        <td>{colaborador.CARNET_SEXO}</td>
                                        <td style={{ fontSize: '13px' }}>{colaborador.CARGO}</td>
                                        <td id={colaborador.EMPRESA_SUCURSAL} >{colaborador.SUCURSAL}</td>
                                        <td>{colaborador.TURNO}</td>
                                        <td style={{ fontSize: '13px' }}>
                                            <div>{colaborador.NOMBRE_TIPO_CONTRATO}</div>
                                            <div>{getAntiguedad(colaborador.ANTIGUEDAD)}</div>
                                        </td>
                                        <td>
                                            <button className='btn btn-sm btn-transparent text-light fs-5 m-0 p-0'
                                                title={`Mostrar link para que responda el colaborador ${colaborador.NOMBRE_COMPLETO}`}
                                                onClick={() =>generarLinkEncuesta(colaborador)}>
                                                <i className="fa-solid fa-ellipsis"></i></button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            <Modal show={showModal} onHide={() => setShowModal(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                contentClassName='bg-dark bg-gradient'
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton closeVariant='white'>
                    <Modal.Title bsPrefix='text-light m-0 p-0 lh-1' id="contained-modal-title-vcenter">
                        Link Para el colaborador
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='m-1 p-0'>
                    {selectColaborador!=null&&
                    <div>
                        <div className='text-light fw-bold'>{selectColaborador.NOMBRE_COMPLETO}</div>
                        <textarea className='form-control text-center' 
                        value={urlFinal} />
                    </div>
                    }
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ListaColaboradorLink